import React from 'react';
import './WhatsAppButton.css';

const WhatsAppButton = () => {
  const phoneNumber = '2348023046244'; // Format: Country code + number without leading 0
  const message = 'Hello! I am interested in your services.';

  return (
    <a 
      href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`}
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <svg 
        viewBox="0 0 32 32" 
        className="whatsapp-icon"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M16 2C8.268 2 2 8.268 2 16c0 2.65.688 5.14 1.885 7.29L2.27 28.52l5.448-1.428A14.032 14.032 0 0016 30c7.732 0 14-6.268 14-14S23.732 2 16 2zm0 25.5c-2.348 0-4.56-.71-6.425-1.928l-.46-.3-3.778.99.988-3.69-.302-.48A11.45 11.45 0 0116 4.5c6.34 0 11.5 5.16 11.5 11.5S22.34 27.5 16 27.5zm7.338-8.62c-.402-.202-2.378-1.174-2.746-1.308-.368-.135-.636-.202-.904.2-.268.402-1.038 1.306-1.272 1.574-.234.268-.47.3-.87.102-2.028-1.01-3.344-1.748-4.666-4.02-.178-.306.178-.284.51-.948.068-.134.034-.252-.016-.352-.05-.1-.452-1.09-.62-1.492-.164-.392-.33-.338-.452-.344l-.384-.006c-.134 0-.35.05-.534.252-.184.202-.704.688-.704 1.676 0 .99.72 1.944.82 2.08.1.134 1.418 2.162 3.434 3.03.48.208.854.332 1.144.424.478.152.914.13 1.258.078.388-.058 2.378-.972 2.712-1.91.336-.938.336-1.742.236-1.91-.102-.168-.37-.268-.772-.468z"/>
      </svg>
    </a>
  );
};

export default WhatsAppButton;
